import Resource from '@/api/Resource';
import Presentation from '@/models/Presentation';
import Category from '@/models/Category';

export default class Lesson extends Resource {
  $name = 'lessons';

  $defaults() {
    return {
      id: null,
      name: '',
      description: '',
      category_id: null,
      minimal_viewing_time: null,
      start_date: null,
      end_date: null,
    };
  }

  $fill({ presentations, category }) {
    if (presentations) {
      this.presentations = Presentation.collection(presentations);
    }

    if (category) {
      this.category = new Category(category);
      this.category_id = this.category.id;
    }
  }

  get type() {
    return {
      name: 'Презентация',
      icon: 'presentation',
    };
  }

  get totalSlides() {
    if (this.presentations) {
      const presentation = this.presentations.first();
      if (presentation && presentation.slides) {
        return presentation.slides.length;
      }
    }
    return 0;
  }

  get thumbnail() {
    if (this.presentations) {
      const presentation = this.presentations.first();
      if (presentation && presentation.slides && presentation.slides.length) {
        return presentation.slides[0].thumbnail;
      }
    }
    return null;
  }
}
